import styled from "styled-components";

import FlyingCircuit from "@/pages/session-detail/components/deprecated/flying-circuit-3d";
import TimelineChartFlight from "@/pages/session-detail/components/deprecated/timeline-chart-flight";
import { PrimaryButton, TertiaryButton } from "@/pages/shared/shared.styles";

import Input from "@/components/ui/input";
import { Wrapper } from "@/components/ui/input/input.styles";

import base from "@/themes/base/base";

export const ModalContentWrapperDiv = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 100%;
    width: 100%;
`;

export const ModalContentWrapperForScrollableContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: var(--spacing-24);
    height: 100%;
`;

interface ComponentsWrapperProps {
    scrollableContainerHeight: number;
}

export const ComponentsScrollableWrapper = styled.div.withConfig({
    shouldForwardProp: (prop) => !["scrollableContainerHeight"].includes(prop),
})<ComponentsWrapperProps>`
    display: flex;
    flex-direction: column;
    gap: var(--spacing-24);
    height: ${({ scrollableContainerHeight }) => `${scrollableContainerHeight}px`};
    overflow-y: scroll;
    position: relative;

    //these two attributes allow placing the scrollbar inside the 'padding' of the modal
    //1.25rem (negative margin for scrollbar offset) - 0.75rem (right padding) = 0.5rem (scrollbar width)
    padding: 0 var(--spacing-12) 0 var(--spacing-24); //adds padding inside the scrollable wrapper
    margin: 0 -1.25rem 0 -1.5rem; //negative margin shift the content outward by the same amount as the padding

    //scrollbar
    &::-webkit-scrollbar {
        width: 0.5rem;
    }

    //draggable indicator
    &::-webkit-scrollbar-thumb {
        background-color: ${base.colors.neutral.grey[600]};
    }

    //scrollbar track
    ::-webkit-scrollbar-track {
        background: transparent;
    }

    & > :last-of-type {
        margin-bottom: var(--spacing-24);
    }
`;

export const Title = styled.span`
    font-family: "Roboto";
    ${base.typography.extraLarge2Regular};

    color: ${base.colors.neutral.grey[50]};
    text-align: center;
`;

export const Description = styled.span`
    font-family: "Roboto";
    ${base.typography.baseRegular};

    color: ${base.colors.neutral.grey[50]};
    text-align: center;
    padding-top: var(--spacing-12);
`;

export const LogoutDescription = styled.span`
    font-family: "Roboto";
    ${base.typography.extraLargeMedium};

    color: ${base.colors.neutral.grey[50]};
    text-align: center;
`;

export const DeleteAccountDescription = styled.span`
    font-family: "Roboto";
    ${base.typography.extraLargeMedium};

    color: ${base.colors.neutral.grey[50]};
    text-align: center;
`;

export const ErrorDescription = styled.span`
    font-family: "Roboto";
    ${base.typography.baseRegular};

    color: ${base.colors.semantic.red[500]};
    text-align: center;
    padding-top: var(--spacing-12);
`;

export const Email = styled.span`
    font-family: "Roboto";
    ${base.typography.baseMedium};
`;

export const StyledEmail = styled.a`
    font-family: "Roboto";
    ${base.typography.extraLargeMedium};

    color: ${base.colors.primary.orange[500]};
    text-decoration: underline;
    text-decoration-thickness: from-font;

    &:hover {
        color: ${base.colors.primary.orange[300]};
    }

    &:visited {
        color: ${base.colors.primary.purple[500]};
    }
`;

export const ButtonsWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: var(--spacing-24);
    padding-top: var(--spacing-24);
    width: 100%; //for the buttons to occupy 100% of width
`;

export const StyledConfirmButton = styled(PrimaryButton)``;

export const StyledCancelButton = styled(TertiaryButton)``;

export const StyledInput = styled(Input)`
    background-color: ${base.colors.neutral.grey[900]};
    border-radius: 0.125rem;

    ${Wrapper} {
        ${base.typography.smallRegular};

        background-color: ${base.colors.neutral.grey[900]};
        padding: var(--spacing-8) var(--spacing-12);

        & input {
            ${base.typography.smallRegular};

            color: ${base.colors.neutral.grey[50]};
            margin-top: 0;
            height: var(--spacing-24);

            &::placeholder {
                color: ${base.colors.neutral.grey[500]};
            }
        }
    }
`;

export const AddUserErrorMessage = styled.span`
    font-family: "Roboto";
    ${base.typography.baseRegular};

    text-align: center;
    color: ${base.colors.semantic.red[500]};
    padding-top: var(--spacing-12);
`;

export const NotAddedUsersWrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    padding-top: var(--spacing-12);
`;

export const NotAddedUser = styled.span`
    font-family: "Roboto";
    ${base.typography.baseMedium};

    color: ${base.colors.semantic.red[500]};
`;

//Scoring component - rendered by CircuitScoring
export const RightContentWrapperDiv = styled.div`
    display: flex;
    position: relative;
`;

export const FlyingCircuitAndTimelineChartWrapper = styled.div`
    display: flex;
    gap: var(--spacing-24);
`;

export const StyledFlyingCircuit = styled(FlyingCircuit)`
    width: 50%;
`;

export const StyledTimelineChartFlight = styled(TimelineChartFlight)`
    width: 50%;
`;

export const PhaseScoreAndFireMissionWrapper = styled.div`
    display: flex;
    gap: var(--spacing-24);
`;

export const PhaseScoringWrapper = styled.div`
    display: flex;
    width: 33.3%;
`;

export const CommunicationTimelineWrapper = styled.div`
    display: flex;
    width: 66.7%;
`;

//Intercept Modal - rendered by ProgressScore
export const CognitiveLoadWrapper = styled.div`
    display: flex;
    width: 33.3%;
`;

export const ProgressScoreWrapper = styled.div`
    display: flex;
    width: 66.7%;
`;

export const FlightPathAndEyeTrackingWrapper = styled.div`
    display: flex;
    width: 100%;
`;
